module.exports = __webpack_public_path__ + "img/service-solo.0cd40ce5.jpg";